import { Navigate } from 'react-router-dom';

import DashboardLayout from './components/DashboardLayout';
import MainLayout from './components/MainLayout';
import Account from './pages/Account';
import AccountList from './pages/AccountList';
import ApprovalRefund from './pages/ApprovalList';
import BankLookup from './pages/BankLookup';
import CustomerCareHistoryList from './pages/CustomerCareHistoryList';
import CustomerCareList from './pages/CustomerCareList';
import CustomerList from './pages/CustomerList';
import CustomerLookup from './pages/CustomerLookup';
import CustomerMessage999 from './pages/CustomerMessage999';
import CustomerMessage9084 from './pages/CustomerMessage9084';
import Dashboard from './pages/Dashboard';
import Division from './pages/Division';
import Giahoantien from './pages/Giahoantien';
import Invitation from './pages/Invitation';
import Login from './pages/Login';
import Logout from './pages/Logout';
import NotFound from './pages/NotFound';
import PermissionList from './pages/PermissionList';
import Register from './pages/Register';
import Report90849332List from './pages/Report90849332List';
import ReportstaffrevenueList from './pages/ReportstaffrevenueList';
import ReportbranchrevenueList from './pages/ReportbranchrevenueList';
import TilebatsoList from './pages/TilebatsoList';
import TinhluongList from './pages/TinhluongList';
import DsdttinhluongList from './pages/DsdttinhluongList';
import Requestrefund from './pages/Requestrefund';
import Requestrefundreport from './pages/Requestrefundreport';
import RoleList from './pages/RoleList';
import Settings from './pages/Settings';
import Systemaccount from './pages/Systemaccount';
import Quetdata from './pages/Quetdata';
import Quetdatakhonggoi from './pages/Quetdatakhonggoi';
import Quetdtct from './pages/Quetdtct';
import UploadList from './pages/UploadList';
import Uploadchiadata from './pages/Uploadchiadata';
import Phanquyendata from './pages/Phanquyendata';
import Chiadata from './pages/Chiadata';
import Chamsoc from './pages/Chamsoc';
import Khr from './pages/Khr';
import Baodo from './pages/Baodo';
import Blacklist from './pages/Blacklist';
import LstracuuLookup from './pages/LstracuuLookup';
import Giagoimfy from './pages/Giagoimfy';
import Mfy from './pages/Mfy';
import Moigoihomsau from './pages/Moigoihomsau';
import Simso from './pages/Simso';
import Baiviet from './pages/Baiviet';
import Order from './pages/Order';
import Simdata5g from './pages/Simdata5g';
import Simdata5gorder from './pages/Simdata5gorder';
import _HomePage from './pages/_HomePage';

import TheHomepageMainLayout from './components/__TheHomepage/MainLayout';

import TheHomepageSimsoDetail from './components/__TheHomepage/SimsoDetail';
import TheHomepageSimsoOne from './components/__TheHomepage/SimsoOne';

import TheHomepageBaivietDetail from './components/__TheHomepage/BaivietDetail';
import TheHomepageBaivietOne from './components/__TheHomepage/BaivietOne';

import TheHomepageTintucDetail from './components/__TheHomepage/TintucDetail';
import TheHomepageTintucOne from './components/__TheHomepage/TintucOne';

import TheHomepageSimdata5gDetail from './components/__TheHomepage/Simdata5gDetail';
import TheHomepageSimdata5gOne from './components/__TheHomepage/Simdata5gOne';

import TheHomepageGoicuoc5gDetail from './components/__TheHomepage/Goicuoc5gDetail';
import TheHomepageGoicuoc5gOne from './components/__TheHomepage/Goicuoc5gOne';

import TheHomepageYnghiasimDetail from './components/__TheHomepage/YnghiasimDetail';

import CreatePost from './pages/CreatePost';

const routes = [
  {
    path: 'app',
    element: <DashboardLayout />,
    children: [
      { path: 'home', element: <_HomePage /> },
      { path: 'dashboard', element: <Dashboard /> },
      { path: 'care-history', element: <CustomerCareHistoryList /> },
      { path: 'customer-care', element: <CustomerCareList /> },
      { path: 'customer-lookup', element: <CustomerLookup /> },
      { path: 'customer-message-999', element: <CustomerMessage999 /> },
      { path: 'customer-message-9084', element: <CustomerMessage9084 /> },
      { path: 'bank-lookup', element: <BankLookup /> },
      { path: 'invite', element: <Invitation /> },
      { path: 'request-sms', element: <Account /> },
      { path: 'approval', element: <ApprovalRefund /> },
      { path: 'requestrefund', element: <Requestrefund /> },
      { path: 'requestrefundreport', element: <Requestrefundreport /> },
      { path: 'report90849332', element: <Report90849332List /> },
      { path: 'reportstaffrevenue', element: <ReportstaffrevenueList /> },
      { path: 'reportbranchrevenue', element: <ReportbranchrevenueList /> },
      { path: 'tilebatso', element: <TilebatsoList /> },
      { path: 'dsdttinhluong', element: <DsdttinhluongList /> },
      { path: 'tinhluong', element: <TinhluongList /> },
      { path: 'chamsoc', element: <Chamsoc /> },
      { path: 'khr', element: <Khr /> },
      { path: 'baodo', element: <Baodo /> },
      { path: 'blacklist', element: <Blacklist /> },
      { path: 'mfy', element: <Mfy /> },
      { path: 'moigoihomsau', element: <Moigoihomsau /> },
      { path: 'simso', element: <Simso /> },
      { path: 'baiviet', element: <Baiviet /> },
      { path: 'order', element: <Order /> },
      { path: 'simdata5g', element: <Simdata5g /> },
      // { path: 'simdata5gorder', element: <Simdata5gorder /> },
      { path: 'settings', element: <Settings /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  },
  {
    path: 'sys',
    element: <DashboardLayout />,
    children: [
      { path: 'lstracuu', element: <LstracuuLookup /> },
      { path: 'profile', element: <Account /> },
      { path: 'customers', element: <CustomerList /> },
      { path: 'permissions', element: <PermissionList /> },
      { path: 'roles', element: <RoleList /> },
      { path: 'accounts', element: <AccountList /> },
      { path: 'upload', element: <UploadList /> },
      { path: 'division', element: <Division /> },
      { path: 'dashboard', element: <Dashboard /> },
      { path: 'giahoantien', element: <Giahoantien /> },
      { path: 'giagoimfy', element: <Giagoimfy /> },
      { path: 'systemaccount', element: <Systemaccount /> },
      { path: 'quetdata', element: <Quetdata /> },
      { path: 'quetdatakhonggoi', element: <Quetdatakhonggoi /> },
      { path: 'quetdtct', element: <Quetdtct /> },
      { path: 'uploadchiadata', element: <Uploadchiadata /> },
      { path: 'phanquyendata', element: <Phanquyendata /> },
      { path: 'chiadata', element: <Chiadata /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  },
  {
    path: 'trang-chu',
    element: <TheHomepageMainLayout />,
    children: [
      { path: '', element: <TheHomepageSimsoDetail /> },
      { path: 'sim-so/:itemId', element: <TheHomepageSimsoOne /> },

      { path: 'bai-viet', element: <TheHomepageBaivietDetail /> },
      { path: 'bai-viet/:itemId', element: <TheHomepageBaivietOne /> },

      { path: 'tin-tuc', element: <TheHomepageTintucDetail /> },
      { path: 'tin-tuc/:itemId', element: <TheHomepageTintucOne /> },

      { path: 'sim-data-5g', element: <TheHomepageSimdata5gDetail /> },
      { path: 'sim-data-5g/:itemId', element: <TheHomepageSimdata5gOne /> },

      { path: 'goi-cuoc-5g', element: <TheHomepageGoicuoc5gDetail /> },
      { path: 'goi-cuoc-5g/:itemId', element: <TheHomepageGoicuoc5gOne /> },

      { path: 'y-nghia-sim', element: <TheHomepageYnghiasimDetail /> },
      { path: 'y-nghia-sim/:so_can_tra', element: <TheHomepageYnghiasimDetail /> },
    ]
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      // { path: 'test-create-post', element: <CreatePost /> },
      { path: 'login', element: <Login /> },
      { path: 'logout', element: <Logout /> },
      { path: 'refresh-cache', element: <Logout /> },
      // { path: 'register', element: <Register /> },
      { path: '404', element: <NotFound /> },
      // { path: '/', element: <Navigate to="/app/home" /> },
      { path: '/', element: <Navigate to="/trang-chu" /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  }
];

export default routes;
